import { Outlet } from "react-router-dom";
export default function EditorLayout() {
  return (
    <div className="editor-shell">
      <Outlet />
    </div>
  );
}
